import React from 'react'
import classNames from 'classnames'
import { IconAlertTriangle, IconCircleCheck, IconInfoCircle } from '@tabler/icons-react'

// The bar's three readings of the configuration on screen: something is wrong
// and blocks the save, everything is in order, or there's nothing to say yet.
export const ACTION_BAR_TONE = {
  CRITICAL: 'critical',
  SUCCESS: 'success',
  NEUTRAL: 'neutral',
}

const TONE_ICON = {
  [ACTION_BAR_TONE.CRITICAL]: <IconAlertTriangle />,
  [ACTION_BAR_TONE.SUCCESS]: <IconCircleCheck />,
  [ACTION_BAR_TONE.NEUTRAL]: <IconInfoCircle />,
}

/**
 * Sticky footer for the Notetaker editor: says where the configuration stands
 * and carries every action that acts on the whole of it.
 *
 * @param {string} props.message What the editor has to say about the current state.
 * @param {string} props.tone One of ACTION_BAR_TONE — colors the message and picks its icon.
 * @param {React.ReactNode} props.statusAction An action on the state the message describes
 *   (discarding what it reports as unsaved). It sits with the message rather than with the
 *   actions on the right, which stay a fixed pair that doesn't reflow as the state changes.
 * @param {React.ReactNode} props.children The bar's actions, in the order they should read.
 */
export const NotetakerActionBar = ({
  message,
  tone = ACTION_BAR_TONE.NEUTRAL,
  statusAction,
  children,
}) => {
  return (
    <div className="notetaker-action-bar" data-testid="notetaker-action-bar">
      <div className="notetaker-action-bar__status">
        <div
          className={classNames('notetaker-action-bar__message', `is-${tone}`)}
          data-testid="notetaker-action-bar-message"
        >
          {TONE_ICON[tone]}
          <span>{message}</span>
        </div>
        {statusAction}
      </div>
      <div className="notetaker-action-bar__actions">{children}</div>
    </div>
  )
}
